import { alpha } from '@mui/system';
import { themeObject } from '../../lib';

export const createFeatureDialogStyles = {
    root: {
        '& .MuiDialog-container': {
            backgroundColor: 'rgb(249,251,251)',
        },
        '& .MuiPaper-root': {
            boxShadow: 'none',
            maxWidth: 'none',
            maxHeight: 'none',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            overflow: 'auto',
            '#dialog-button-container.MuiBox-root': {
                zIndex: 10,
                '& .MuiIconButton-root': {
                    top: '69px',
                    right: '68px',
                    mt: 0,
                    width: '34px',
                    height: '34px',
                    p: '6px',
                    '& .MuiSvgIcon-root': {
                        height: '22px',
                        width: '22px',
                    },
                },
            },
        },
    },
    paperStyle: {
        display: 'flex',
        justifyContent: 'center',
        p: '116px 155.5px 183px 155.5px',
        position: 'relative',
    },
    gridStyle: {
        position: 'relative',
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    headingStyle: {
        textAlign: 'center',
        fontSize: '28px',
        fontFamily: 'Raleway',
        color: themeObject.palette.primary[700],
        fontWeight: 600,
        lineHeight: '32.87px',
        mb: 2.5,
    },
    menuListStyle: {
        boxShadow: 'none',
        '& .MuiList-root': {
            padding: 0,
            width: '100%',
            pr: 0.5,
            overflowY: 'scroll',
            '&::-webkit-scrollbar': { width: '8px' },
            '&::-webkit-scrollbar-track': {
                display: 'none',
            },
            '&::-webkit-scrollbar-thumb': {
                background: themeObject.palette.primary[500],
                borderRadius: '100px',
            },
        },
    },
    menuItemStyle: {
        width: '553px',
        border: `1px solid ${themeObject.palette.grayScale[300]}`,
        borderRadius: '8px',
        m: '13px 0',
        p: '0 32px',
        alignItems: 'center',
        height: '95px',
        '&:first-child': {
            mt: 0,
        },
        '&:last-child': {
            mb: 0,
        },
        '&.active': {
            backgroundColor: themeObject.palette.primary[50],
            border: `3px solid ${themeObject.palette.primary[500]}`,
        },
        '&:hover': {
            backgroundColor: alpha(themeObject.palette.primary[50], 0.5),
        },
        '& .MuiFormControlLabel-root': {
            mr: 0,
            '& .MuiRadio-root': {
                backgroundColor: 'transparent',
            },
            '& .Mui-checked': {
                backgroundColor: 'transparent',
                color: themeObject.palette.grayScale[700],
            },
        },
    },
    imgStyle: {
        width: '70px',
    },
    listItemStyle: {
        ml: 5,
        mr: '25px',
        '& span': {
            fontFamily: `${['Raleway', 'Open Sans', 'sans serif'].join(
                ','
            )} !important`,
            fontWeight: `600 !important`,
            fontSize: '18px !important',
            lineHeight: '21px !important',
            color: `${themeObject.palette.primary[700]} !important`,
        },
        '& .MuiTypography-body2': {
            ...themeObject.typography.body1,
            color: themeObject.palette.primary[700],
            lineHeight: '21.17px',
            mt: 1,
            textWrap: 'auto',
        },
    },
    buttonGridStyle: {
        display: 'flex',
        gap: 2.5,
        pr: 1.25,
        mt: 2.5,
    },
    backButtonStyle: { flex: 1 },
    nextButtonStyle: { flex: 1 },
    accordionStyles: {
        width: '585px',
        display: 'flex',
        flexDirection: 'column',
        mb: '20px !important',
    },
    accordionSummaryStyles: {
        width: '100%',
        py: '12px',
    },
};

export interface CreateFeatureMenuItem {
    title: string;
    subtitle: string;
    icon: string | undefined;
    navigationPath: string;
    styles?: any;
}

export interface CreateAccordionMenuItemsData {
    heading: string;
    menuItems: CreateFeatureMenuItem[];
    isExpanded: boolean;
}

export interface FeatureItems {
    [key: string]: CreateFeatureMenuItem;
}
